// const FormStepper = ({ steps, activeStep, onChange }) => {
//   return (
//     <div className="flex items-center gap-4 pb-3 mb-4 overflow-x-auto">
//       {steps.map((step, index) => {
//         const isActive = index === activeStep;
//         const isCompleted = index < activeStep;

//         return (
//           <button
//             key={step.id}
//             type="button"
//             onClick={() => onChange(index)}
//             className={`
//               flex items-center gap-2 text-sm px-3 py-1 rounded-full whitespace-nowrap
//               ${isActive && "bg-blue-600 text-white"}
//               ${!isActive && isCompleted && "bg-green-100 text-green-700"}
//               ${!isActive && !isCompleted && "bg-gray-100 text-gray-600"}
//             `}
//           >
//             <span className="font-semibold">{index + 1}</span>
//             {step.label}
//           </button>
//         );
//       })}
//     </div>
//   );
// };

// export default FormStepper;
// const FormStepper = ({ steps, activeStep, onChange }) => {
//   return (
//     <div className="w-full flex justify-center">
//       <div className="flex items-center justify-between w-full max-w-4xl">
//           {steps.map((step, index) => {
//             const isActive = index === activeStep;
//             const isCompleted = index < activeStep;

//             return (
//               <div key={step.id} className="flex-1 flex flex-col items-center">

//                 {/* Step Circle */}
//                 <button
//                   type="button"
//                   onClick={() => onChange(index)}
//                   className={`
//                     w-8 h-8 flex rounded-full text-xs font-semibold
//                     flex items-center justify-center
//                     transition-colors duration-200
//                     ${
//                       isActive
//                         ? "bg-blue-600 text-white"
//                         : isCompleted
//                         ? "bg-green-600 text-white"
//                         : "bg-gray-200 text-gray-600"
//                     }
//                   `}
//                 >
//                   {index + 1}
//                 </button>

//                 {/* Label */}
//                 <span
//                   className={`
//                     mt-2 text-xs text-center
//                     ${
//                       isActive
//                         ? "text-blue-600"
//                         : isCompleted
//                         ? "text-green-600"
//                         : "text-gray-500"
//                     }
//                   `}
//                 >
//                   {step.label}
//                 </span>

//                 {/* Connector Line */}
//                 {index < steps.length - 1 && (
//                   <div
//                     className={`
//                       absolute top-4 left-1/2 w-full h-0.5 -z-10
//                       ${isCompleted ? "bg-green-600" : "bg-gray-300"}
//                     `}
//                   />
//                 )}
//               </div>
//             );
//           })}
//       </div>
//     </div>
//   );
// };

// export default FormStepper;

// const FormStepper = ({ steps, activeStep, onChange }) => {
//   return (
//     <div className="w-full flex justify-center">
//       <div className="relative w-full max-w-4xl px-4">

//         {/* Background line */}
//         <div className="absolute top-4 left-5 right-4 h-0.5 bg-gray-300" />

//         {/* Progress line */}
//         <div
//           className="absolute top-4 left-5 h-0.5 bg-green-600 transition-all duration-300"
//           style={{
//             width: `${(activeStep / (steps.length - 1)) * 100}%`,
//             maxWidth: "calc(100% - 0px)",
//           }}
//         />

//         {/* Steps */}
//         <div className="relative flex justify-between">
//           {steps.map((step, index) => {
//             const isActive = index === activeStep;
//             const isCompleted = index < activeStep;

//             return (
//               <div
//                 key={step.id}
//                 className="flex flex-col items-center text-center"
//               >
//                 {/* Circle */}
//                 <button
//                   type="button"
//                   onClick={() => onChange(index)}
//                   className={`
//                     w-8 h-8 rounded-full text-xs font-semibold
//                     flex items-center justify-center z-10
//                     ${
//                       isActive
//                         ? "bg-blue-600 text-white"
//                         : isCompleted
//                         ? "bg-green-600 text-white"
//                         : "bg-gray-200 text-gray-600"
//                     }
//                   `}
//                 >
//                   {index + 1}
//                 </button>

//                 {/* Label (only active) */}
//                 <span className={`
//                 mt-2 text-xs whitespace-nowrap
//                 ${
//                   isActive
//                     ? "text-blue-600"
//                     : isCompleted
//                     ? "text-green-600"
//                     : "text-gray-600"
//                 }
//                 `}>
//                   {step.label}
//                 </span>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FormStepper;

import { useRef } from "react";

const FormStepper = ({ steps, activeStep, onChange }) => {
  const progressPct = steps.length > 1
    ? (activeStep / (steps.length - 1)) * 100
    : 0;

  const activeLabel = steps[activeStep]?.label ?? "";

  return (
    <div className="w-full pt-1 pb-1">
      {/* ── Circles row ── */}
      <div className="relative w-full px-3 md:px-6">
        {/* Background track — vertically centred on the circles */}
        <div className="absolute inset-x-3 md:inset-x-6 top-[14px] md:top-[16px] h-0.5 bg-gray-300" />
        {/* Progress track — width as % of the space between first and last circle */}
        <div
          className="absolute left-3 md:left-6 top-[14px] md:top-[16px] h-0.5 bg-green-600 transition-all duration-300"
          style={{ width: `${progressPct}%` }}
        />

        <div className="relative flex justify-between">
          {steps.map((step, index) => {
            const isActive = index === activeStep;
            const isCompleted = index < activeStep;

            return (
              <div key={step.id} className="flex flex-col items-center">
                {/* Circle */}
                <button
                  type="button"
                  onClick={() => onChange(index)}
                  title={step.label}
                  className={`
                    w-7 h-7 md:w-8 md:h-8 rounded-full text-xs font-bold
                    border-2 border-white flex items-center justify-center z-10
                    transition-colors duration-200 shadow-sm
                    ${isActive    ? "bg-blue-600 text-white"
                    : isCompleted ? "bg-green-600 text-white"
                    :               "bg-gray-200 text-gray-500"}
                  `}
                >
                  {index + 1}
                </button>

                {/* Label — desktop only */}
                <span
                  className={`
                    hidden md:block mt-1.5 text-xs uppercase whitespace-nowrap
                    ${isActive    ? "text-blue-600 font-semibold"
                    : isCompleted ? "text-green-600"
                    :               "text-gray-500"}
                  `}
                >
                  {step.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      {/* ── Mobile-only current step label ── */}
      <p className="md:hidden mt-3 text-center text-xs font-semibold text-blue-700 uppercase tracking-wider">
        Step {activeStep + 1} of {steps.length} — {activeLabel}
      </p>
    </div>
  );
};

export default FormStepper;
